var dateConverter = {
    fromServerConvert(date) {
        if (date.indexOf('-') != -1)
            return date.substr(8, 2) + '.' + date.substr(5, 2) + '.' + date.substr(0, 4);
        else return date
    },
    toServerConvert(date) {
        if (date.indexOf('.') != -1)
            return date.substr(0, 2) + '-' + date.substr(3, 2) + '-' + date.substr(6, 2)
        else return date
    }
}

export default dateConverter